export default "__VITE_ASSET__CmUZoHyr__"